import { render, staticRenderFns } from "./CommonStorageBase.vue?vue&type=template&id=371acbbc&"
import script from "./CommonStorageBase.vue?vue&type=script&lang=js&"
export * from "./CommonStorageBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports